import React, { useState } from "react"
import { ModalContext } from "../context/ModalContext"
import { CustomModalPortal } from "../../../../components/Custom/CustomModalPortal"
import { ModalServices } from "../services/ModalServices"

import modalComponents from "../components/ModalComponentsDetails"
const modalServices = new ModalServices({ modals: modalComponents })

export const ModalProvider = ({ children }) => {
    const [isLoadingModal, setIsLoadingModal] = useState(false)
    const [isActiveModal, setIsActiveModal] = useState(false)
    const [viewModalRender, setViewModalRender] = useState(null)


    const closeModal = () => {
        setIsLoadingModal(false)
        setIsActiveModal(false)
        setViewModalRender(null)
    }

    const closeModalAndRefresh = async ({ getProjectDetails, project }) => {
        await getProjectDetails(project.clickupSpace)
        closeModal()
    }

    const renderModal = async (render) => {
        if (!render) {
            setIsLoadingModal(false)
            return
        }

        setIsLoadingModal(false)
        setIsActiveModal(true)
        setViewModalRender(render)
    }

    const openModal = async ({ type, extraData, project, auth, getProjectDetails }) => {
        setIsLoadingModal(true)
        modalServices.addExtraData({
            project,
            auth,
            getProjectDetails,
            closeModal,
            renderModal,
            closeModalAndRefresh: async () => await closeModalAndRefresh({ getProjectDetails, project })
        })
        await modalServices.setProps(type, extraData)
    }

    const value = {
        isLoadingModal,
        openModal,
    }

    return (
        <ModalContext.Provider value={value}>
            {children}
            <CustomModalPortal isVisible={isActiveModal}>
                {viewModalRender}
            </CustomModalPortal>
        </ModalContext.Provider>
    )

}